<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <template v-if="loading">
        <v-progress-circular>Building email...</v-progress-circular>
      </template>
      <template v-else>
        Email
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <div v-html="email"></div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import firebase from "firebase";

export default {
    name: "EmailBuilder",
    components: {},
    props: {
      samples: {
        required: true,
      },
      customer_name: {
        required: true,
      },
      customer_id: {
        required: true,
      }
    },
    watch: {
      samples:{
        handler(v){
          this.load();
        },
        deep: true,
      },
    },
    data: () => ({
      loading: true,
      email: null,
      links: [],
    }),
    mounted(){
      this.load();
    },
    methods: {
      async load(){
        this.loading = true;
        if(this.links.length === 0){
          await this.loadLinks();
        }
        this.buildEmail();
        this.loading = false;
      },
      async loadLinks(){
        let links = firebase.functions().httpsCallable('reportedCertLinks');
        // console.log(this.samples.map(({id}) => id), 'sampleIds')
        links = await links({collection: this.samples.map(({id}) => id)});
        // console.log(links, "links")
        this.links = links.data;
      },
      buildEmail(){
        this.email = this.emailTop() + this.emailCenter() + this.emailBottom();
        this.$emit("update_customer", [
          this.customer_id,
          {
            email: {
              message: {
                subject: `Test Results ${this.$moment().format("YYYY-MM-DD")}`,
                html: this.email
              }
            }
          }
          ])
      },
      sampleRow(sample){
        let notes = sample.sample_notes.filter(note => note.note_type.name === "Customer");
        notes = notes.length === 0 ? `` : `<br/>` + notes.map((note) => `- ${note.note}`).join("<br/>");
        let links = this.links.find(({id}) => id === sample.id);
        links = links.link;
        console.log(sample, 'BUILDING EMAIL SAMPLE')
        let SDP = sample.required_tests.find(test => test.test_type === "T")
            ? `<br/> - <a href="${links.full.replace("/full/", "/sdp/compass/v1/").replace(".pdf", "")}.csv" target="_blank">SDP Color Category Graph</a>`
            : '';
        let CCRS = `<br/> - <a href="${links.full.replace("/full/", "/wcia/v2_1/").replace(".pdf", "")}.json" target="_blank">WCIA Lab Result Link (JSON)</a>
<br/> - <a href="${links.full.replace("/full/", "/csv/v1/").replace(".pdf", "")}.csv" target="_blank">Spreadsheet (CSV)</a>${SDP}
`
        return `<a href="${links.full.replace("/full/", "/full/download/")}">Download</a> | <a href="${links.full}" target="_blank">${sample.qa}: ${sample.name} (${sample.sample_type_name})</a> ${CCRS} ${notes} <br/>`
      },
      //Format is important here, keep text to left no tabbing in. It is obnoxious but we have to do it to keep editing easy.
      emailCenter(){
        return this.samples.filter((sample) => !sample.dont_send).map(this.sampleRow).join("<br/>");
      },
      emailTop(){
        return `
Hello ${this.customer_name},
<br />
<br />
Your Results for the following samples are now available. Please log into our <a href="https://results.conflabs.com" target="_blank">results portal</a> to view more:
<br />
<br />`
      },
      emailBottom(){
        return `
<br />
<br />
Thank you,
<br />
<br />
Confidence Analytics
<br />
(206) 743-8843
<br />
info@conflabs.com
<br />
www.ConfidenceAnalytics.com
<br />
<br />
We've made changes to our <a href="https://www.conflabs.com/terms-of-service/" target="_blank">Terms of Service</a> and <a href="https://www.conflabs.com/privacy-policy/" target="_blank">Privacy Policy</a>
<br />
Give us feedback about your experience!
<br />
<a href="https://docs.google.com/forms/d/e/1FAIpQLScutGd3BJpUaAqAW-M5ZviQObj1HgXaOrQyeRumX6CeqPtNJg/viewform?usp=dialog">Feedback Survey</a>
<br />
        `
      }
    }
}
</script>

<style scoped>

</style>
